import {getDateString} from "../../utils/Utils";
import {useEffect, useRef, useState} from "react";
import Days from "../../utils/constants/Days";
import "../../css/tablePage/MobileTable.css"
import TeacherConstant from "../../utils/constants/TeacherConstant";
import EmptyCell from "./EmptyCell";
import LessonCell from "./LessonCell";
import TableLegend from "./TableLegend";
import TableControllerAction from "../../utils/constants/TableControllerAction";
import TableWeekController from "./TableWeekController";
let MobileTable = (props) => {
    let [currentDate, setCurrentDate] = useState(new Date())

    let [gridChanged, setGridChanged] = useState(false);
    let tableRef = useRef();
    let timeContainerRef = useRef();

    useEffect(() => {
        setCurrentDate(props.selectedDate)
    }, [props.selectedDate])
    useEffect(() => {
        if (!tableRef || !timeContainerRef || props.dailyTable === null || !tableRef.current || !tableRef.current) return;
        let columnCount = 1;
        if (props.currentTeacher === TeacherConstant.ID_SELECT_ALL) {
            let dayIndex = currentDate.getDay();
            let dayKey = Days.keyset[dayIndex]
            columnCount = props.dailyTable[dayKey].length === 0 ? 1 : props.dailyTable[dayKey].length;
        }
        tableRef.current.style["grid-template-columns"] = 'repeat(' + columnCount + ', minmax(60px, 1fr))'
        let timeCount = Days.timeset.length;
        let rowCount = timeCount + 1;
        tableRef.current.style["grid-template-rows"] = 'repeat(' + rowCount + ', 1fr)'
        timeContainerRef.current.style["grid-template-rows"] = '0.5fr repeat(' + timeCount + ', 1fr) 0.5fr'
        setGridChanged(true);
    }, [props.currentTeacher, props.location, props.dailyTable, currentDate])

    let getDates = () => {
        let startDate = props.startDate;
        let ret = [];
        ret.push(<TableWeekController
            action={TableControllerAction.PREVIOUS}
            startDate={props.startDate}
            onChangeDate={props.onChangeDate}
            isAdmin={props.isAdmin}
        />)
        for (let i = 0; i < 7; i++) {
            let nextDate = new Date(startDate);
            nextDate.setDate(nextDate.getDate() + i)
            let dateString = getDateString(nextDate);
            let id = "lesson-date:" + dateString;
            let isSelected = getDateString(currentDate) === getDateString(nextDate)
            ret.push(<div className={isSelected ? "mobile-lesson-date selected" : "mobile-lesson-date"}
                          key={id} id={id} onClick={(_) => setCurrentDate(nextDate)}>
                <p>{nextDate.getDate()}</p>
                <p>{Days.korean_render[i]}</p>
            </div>)
        }
        ret.push(<TableWeekController
            action={TableControllerAction.NEXT}
            startDate={props.startDate}
            onChangeDate={props.onChangeDate}
            isAdmin={props.isAdmin}
        />)
        return ret;
    }
    let getTeacherName = (teacherid) => {
        if (props.data === null) return "";
        let teachers = props.data.teachers;
        let teacher = teachers[teacherid];
        return TeacherConstant.major_symbol[teacher.major] + teacher.name;
    }
    let isInBannedTimes = (dateString, hour, teacherid) => {
        if (props.bannedTimes === null)
            return false;
        for (let banned of props.bannedTimes) {
            let bannedTime = getDateString(new Date(banned.date))
            if (bannedTime === dateString && hour === banned.hour && banned.teacherid === teacherid)
                return true
        }
        return false;
    }
    let getTable = () => {
        if (props.dailyTable === null || props.table === null) return [];
        let ret = [];
        let dayIndex = currentDate.getDay();
        let dayKey = Days.keyset[dayIndex]
        let teachers = props.dailyTable[dayKey];
        if (teachers.length === 0) {
            return <div className="table-main-cell table-cell-teachername">
                <p>예약 불가능한 요일입니다.</p>
            </div>
        }
        if (props.currentTeacher !== TeacherConstant.ID_SELECT_ALL) {
            teachers = [props.currentTeacher]
        }
        for (let teacherid of teachers) {
            let key = getTeacherName(teacherid)
            ret.push(<div className="table-main-cell table-cell-teachername" key={key}>
                <p className="table-cell-teachername-text">
                    {key}
                </p>
            </div>)
            for (let i = 0; i < Days.timeset.length; i++) {
                let hour = Days.timeset[i];
                let isBanned = Days.timeset_banned.includes(hour);

                if (typeof teacherid === "undefined" || props.table[teacherid].times[dayKey].indexOf(hour) === -1) isBanned = true;
                let currentDateString = getDateString(currentDate)

                isBanned ||= isInBannedTimes(currentDateString, hour, teacherid)
                key = "empty-" + key + i
                ret.push(<EmptyCell key={key} isBanned={isBanned} dateString={currentDateString}
                                    dueDate={currentDate} teacherid={teacherid} hour={hour} data={props.data}
                                    location={props.location} needUpdate={props.needUpdate}
                                    setNeedUpdate={props.setNeedUpdate} isAdmin={props.isAdmin}
                                    myInformation={props.myInformation} setNeedInfoRefresh={props.setNeedInfoRefresh}></EmptyCell>)
            }
        }
        for (let lesson of props.lessons) {
            let teacherid = lesson.teacherid;
            let key = "lesson:" + lesson.lessonid;
            let indexOffset = teachers.indexOf(teacherid) * (Days.timeset.length + 1)
            let dueString = getDateString(new Date(lesson.due))
            let currentDateString = getDateString(currentDate)
            if (indexOffset < 0 || dueString !== currentDateString) continue;
            let hour = lesson.hour
            let hourIndex = Days.timeset.indexOf(hour);
            if (props.currentTeacher !== TeacherConstant.ID_SELECT_ALL && props.currentTeacher !== lesson.teacherid) continue;

            let index = indexOffset + hourIndex + 1;
            ret[index] = <LessonCell data={props.data} lesson={lesson}
                                     key={key + index} needUpdate={props.needUpdate}
                                     setNeedUpdate={props.setNeedUpdate} isAdmin={props.isAdmin}
                                     myInformation={props.myInformation} setNeedInfoRefresh={props.setNeedInfoRefresh}
            />
        }
        return ret;
    }
    let getTimes = () => {
        let ret = [];
        ret.push(<div className="mobile-time-cell" key={"mobile-time-cell-first"}></div>)
        for (let time of Days.timeset) {
            let key = "left-time:" + time + ":00"
            ret.push(<div className="mobile-time-cell" key={key}>
                <p className="table-sidebar-text">
                    {time + ":00"}
                </p>
            </div>)
        }
        return ret;
    }
    return <>
        <div className="mobile-date-container">
            {getDates()}
        </div>
        <TableLegend></TableLegend>
        <div className="mobile-table-content">
            <div className="mobile-time-container" ref={timeContainerRef}>
                {gridChanged ? getTimes() : null}
            </div>
            <div className="mobile-table" ref={tableRef}>
                {gridChanged ? getTable() : null}
            </div>
        </div>
    </>
}
export default MobileTable;
